import type { CategoryDefinition } from '@/types';

export const hvacCategories: readonly CategoryDefinition[] = [
  { id: 'hvac.service',      name: 'Service',      icon: 'fan',         color: 'cyan',    order: 1, description: 'Routine servicing per unit' },
  { id: 'hvac.installation', name: 'Installation', icon: 'snowflake',   color: 'sky',     order: 2, description: 'Fitting and removal' },
  { id: 'hvac.repair',       name: 'Repair',       icon: 'wrench',      color: 'slate',   order: 3, description: 'Component and refrigerant faults' },
  { id: 'hvac.inspection',   name: 'Inspection',   icon: 'badge-check', color: 'emerald', order: 4, description: 'Diagnostics and reports' },
];
